export interface WlasTabDef {
  key: string;
  labelKey: string;
  disabled?: boolean;
}

export const WLAS_TABS: WlasTabDef[] = [
  { key: 'configuration', labelKey: 'tabs.configuration' },
  { key: 'billing', labelKey: 'tabs.billing', disabled: true },
];
